export default "__VITE_ASSET__BwGwhiKN__"